"use client";
import InputField from "../../../components/common/InputField";
import TextareaField from "../../../components/common/TextareaField";

export const SystemTypes = [
  { value: "phone", text: "Phone" },
  { value: "email", text: "Email" },
  { value: "whatsapp", text: "WhatsApp" },
];
const AddCompanyModal = () => {
  return (
    <div className="w-[655px] p-4 space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <InputField label="Company Name" placeholder="Blue Logistics" />
        <InputField label="Contact" placeholder="98531710210" />
        <InputField
          label="Email"
          className="col-span-2"
          placeholder="Ford Transit"
        />
        <TextareaField
          name='address'
          className="col-span-2"
          label="Address"
          placeholder="Enter Address"
        />
      </div>
    </div>
  );
};

export default AddCompanyModal;
